class TabItem {
  constructor(primaryText, meta) {
    this.primaryText = primaryText;
    this.meta = meta;
  }
}

export { TabItem };
